import { useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import BoxWrapper from "../../components/BoxWrapper";
import Pagination from "../../components/Pagination";
import RenderTable from "../../components/RenderTable";
import { NotificationsSvg } from "../../components/SideBarMenu";
import { pluralize, toQuery } from "../../helpers/general";
import { useCookie } from "../../hooks/useCookie";
import { general } from "../../locales/general";
import apiService from "../../service/apiService";
import AdminRoute from "../auth/RestrictedRoute";
import NotificationsTable from "./NotificationsTable";

const PAGE_SIZE = 10;

export default function Notifications() {
  const [currentPage, setCurrentPage] = useState(1);
  const { token } = useCookie("vToken");

  const endpoint = `notifications/scheduled${toQuery({
    page: currentPage,
    limit: PAGE_SIZE,
  })}`;
  const queryKeys = ["getAllNotifications", token, currentPage, endpoint];
  const { data, isLoading, isPreviousData } = useQuery(queryKeys, (query) => {
    return apiService.MakeGetRequest(endpoint, query.queryKey[1]);
  });

  return (
    <AdminRoute>
      <section>
        <h5 className="fs-4 fw-bold mb-2">Notifications</h5>
        <BoxWrapper>
          <div className="d-flex flex-column-reverse flex-md-row justify-content-between align-items-start align-items-md-baseline">
            <div className="d-flex col-12 col-md-6 align-items-center gap-2 p-3 delete-add">
              <Link
                to="/notifications/new"
                className="btn btn-primary rounded-pill text-white d-flex align-items-center gap-2 justify-content-center shadow-secondary"
              >
                + Ajouter une notification
              </Link>
            </div>
            <div
              className="d-flex col-12 col-md-5 col-lg-4 col-xl-3 align-items-center justify-content-center gap-3 bg-gradient-primary p-3"
              style={{ borderTopRightRadius: "8px", alignSelf: "flex-start" }}
            >
              <NotificationsSvg className="fill-white" />
              <p className="fs-5 fw-bold m-0 text-white">
                {data?.meta?.totalItems}{" "}
                {pluralize("Notification", data?.meta?.totalItems)}
              </p>
            </div>
          </div>
          <RenderTable
            loading={isLoading || isPreviousData}
            render={() =>
              data?.items?.length > 0 ? (
                <NotificationsTable
                  notifications={data?.items as ScheduledNotification[]}
                />
              ) : (
                <p className="text-center fs-5 my-2">{general.fr.noData}</p>
              )
            }
          />
        </BoxWrapper>
        <Pagination
          currentPage={currentPage}
          onPageChange={(page) => {
            setCurrentPage(page);
          }}
          siblingCount={0}
          totalCount={data?.meta?.totalPages}
          pageSize={PAGE_SIZE}
        />
      </section>
    </AdminRoute>
  );
}
